/*
 * The frame every Settings page shares (DESIGN.md §6.1, §7): the Settings areas (their own
 * module, settings-nav.module.css), then the page's title with one sentence on what it is
 * for, then the page, its parts 24px apart. Tokens only.
 */

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  min-width: 0;
}

/* The title's own bottom margin is replaced by the gap above. */
.body > :nth-child(-n + 2) {
  margin-bottom: 0;
}

/* A record page's way back to its list sits tight above the title. */
.body > .back {
  margin-bottom: calc(var(--space-3) - var(--space-5));
  font: var(--t-small);
}
